import { defineComponent as _defineComponent } from 'vue'
import { AUTH_FLOW_STEPS } from '~/core/services/utils/Constants';
import { isValidEmail } from '~/core/validators/email';
import { ref, watch, onMounted, computed, onUnmounted, useContext, useRouter } from "@nuxtjs/composition-api";
import { ACTIONS as ACTIONS_USER_FEEDBACK } from '~/store/affility/user/feedback/names';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthCore',
  emits: ['onFlowFinished', 'onStepTransition'],
  setup(__props, { expose, emit: $emit }) {



const flow = ref(AUTH_FLOW_STEPS);
const step = ref(AUTH_FLOW_STEPS.SIGN_UP_WITH_EMAIL);
const flowHistory = ref([]);
const currentStepInitialData = ref(null);

const context = useContext();
const router = useRouter();

const authCoreStep = computed(() => context.store.getters['application/driver/authCoreStep']);
const user = computed(() => context.store.getters['application/driver/authUser']);

const onFlowFinished = () => {
    setTimeout(() => {
        $emit('onFlowFinished');
        router.push('/dashboard');
        if (user.value?.isUMUser) {
            router.push('/account');
        }
    }, 100);
}

const handleSignup = ({ email }) => {
    context.store.dispatch(
        `affility/user/feedback/${ACTIONS_USER_FEEDBACK.SHOW_SUCCESS_MODAL}`,
        {
            title: context.i18n.t('email_verification_sent_title'),
            desc: context.i18n.t(`email_verification_sent_description`, { email }),
            buttonAttrs: { id: 'auth-email-verification-ok-button' },
        }
    );

    onFlowFinished();
}

const stepTransition = (stepToTransition, stepStateToSave = null) => {
    let currentStepData = null;
    if (stepToTransition === AUTH_FLOW_STEPS.FORGOT_PASSWORD && isValidEmail(stepStateToSave.email)) {
        currentStepData = stepStateToSave;
    }
    const lastIndex = flowHistory.value.map(el => el.step).lastIndexOf(stepToTransition);
    if (lastIndex !== -1) {
        currentStepData = flowHistory.value[lastIndex].stepState;
    }
    if (stepToTransition === AUTH_FLOW_STEPS.TWO_FACTOR_CODE) {
        currentStepData = stepStateToSave;
    }
    currentStepInitialData.value = currentStepData;

    flowHistory.value.push({
        step: step.value,
        stepState: stepStateToSave,
    });
    context.store.dispatch('application/driver/setAuthStep', stepToTransition);
    $emit('onStepTransition', stepToTransition);
}

const stepBack = () => {
    if (canGoBack()) {
        flowHistory.value.forEach(item => {
            if (step.value === step.value) {
                item.stepState = currentStepInitialData.value;
            }
        });
        const previousStepData = flowHistory.value.pop();
        currentStepInitialData.value = previousStepData.stepState;
        context.store.dispatch('application/driver/setAuthStep', previousStepData.step);
    }
}

const canGoBack = () => {
    return flowHistory.value.length > 0;
}

onMounted(() => {
    if (authCoreStep.value) {
        step.value = authCoreStep.value;
    }
})

watch(authCoreStep, (newVal) => {
    if (newVal) {
        step.value = newVal;
    }
})

onUnmounted(() => {
    context.store.dispatch('application/driver/setAuthStep', null);
})

expose({
    stepBack,
    canGoBack,
})

return { __sfc: true,$emit, flow, step, flowHistory, currentStepInitialData, context, router, authCoreStep, user, onFlowFinished, handleSignup, stepTransition, stepBack, canGoBack }
}

})